import React, { useState } from 'react';
import { AppliancesTable } from './appliances_table';
import { FilterSection } from "@/components/ui/FilterSection";

const AppliancesTab = () => {
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({ date: "all", fromDate: "", toDate: "", status: "Pending" });

  const STATUS_OPTIONS = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Paid", label: "Paid" },
    { value: "Partially Paid", label: "Partially Paid" }
  ];

  const handleSetFilters = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="w-full flex flex-col gap-4 animate-in fade-in duration-300">
      <div className="flex flex-col rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] min-w-0">
        <FilterSection 
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={handleSetFilters}
          showExport={false}
          statusOptions={STATUS_OPTIONS}
          statusPlaceholder="All Statuses"
        />
      </div>
      <div className="flex-1 mt-2">
        <AppliancesTable search={search} filters={filters} />
      </div>
    </div>
  );
};

export default AppliancesTab;
